import React from 'react'

export const SimpleDownloadIcon = ({ color = '#0246F8' }) => (
  <svg width='21' height='21' viewBox='0 0 21 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M7.21875 9.09375L10.5 12.3741L13.7812 9.09375'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M10.5 3.625V12.3727' stroke='#0246F8' strokeLinecap='round' strokeLinejoin='round' />
    <path
      d='M17.375 12.375V16.75C17.375 16.9158 17.3092 17.0747 17.1919 17.1919C17.0747 17.3092 16.9158 17.375 16.75 17.375H4.25C4.08424 17.375 3.92527 17.3092 3.80806 17.1919C3.69085 17.0747 3.625 16.9158 3.625 16.75V12.375'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
